import React from 'react';
import ShowContainer from './ShowContainer';
import { IconButton } from '@mui/material';
import CusItemTooltip from './CusItemTooltip';
import { IconPin, IconPinFilled } from '@tabler/icons-react';
import useColor from '../../hooks/site/useColor';
import useBootstrapSize from '../../hooks/useBootstrapSize';

export default function PinElement({ pined, setPined, conditionPin = true }) {
  const { primary } = useColor();

  return (
    <ShowContainer condition={conditionPin}>
      <IconButton onClick={() => setPined((prev) => !prev)}>
        <CusItemTooltip
          text={pined ? 'Unpin' : 'Pin'}
          elem={
            pined ? (
              <IconPinFilled style={{ color: primary.main }} />
            ) : (
              <IconPin style={{ color: primary.main }} />
            )
          }
        />
      </IconButton>
    </ShowContainer>
  );
}
